var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-group-container",class:[{'is-disabled': _vm.disabled}, {'is-btn-group': _vm.isBtnGroup}],attrs:{"name":"checkbox-group"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }